import { getVoucherDownload } from "@/services/core-api-adapter";
import type { QueryClient } from "@tanstack/react-query";

export const voucherDownloadQueryKeyPrefix = ["voucherDownload"] as const;

export const voucherDownloadQueryKey = (voucherOrderId: string) =>
  [...voucherDownloadQueryKeyPrefix, voucherOrderId] as const;

/**
 * Returns the voucher PDF blob for an order, fetching it only on the first call
 * for a given `voucherOrderId` and serving the cached blob on subsequent shares.
 *
 * `voucherOrderId` is the immutable identity the download endpoint keys on, so a
 * new order always produces a different key (cache miss) — we never share a
 * stale PDF. `staleTime: Infinity` because an order's PDF never changes.
 */
export function fetchCachedVoucherDownload(
  queryClient: QueryClient,
  voucherOrderId: string
): Promise<Blob> {
  return queryClient.ensureQueryData({
    queryKey: voucherDownloadQueryKey(voucherOrderId),
    queryFn: ({ signal }) => getVoucherDownload(voucherOrderId, { signal }),
    staleTime: Infinity,
    gcTime: 1000 * 60 * 30,
  });
}
